// utils/categoryEmoji.js
//
// Categories live in Firestore clubs_categories (name/order only, no emoji
// field), so the emoji map is client-side. Unknown/new categories show no emoji.

const CATEGORY_EMOJI = {
  academic: "📚",
  "club sports": "⚽",
  communities: "🏘️",
  "community outreach and social change": "🤝",
  "greek life": "🏛️",
  "greek life programming": "🎉",
  "graduate student organizations": "🎓",
  "health and wellness": "🧘",
  "media & publications": "📰",
  "multicultural and identity-based": "🌍",
  "performing arts": "🎭",
  "programming boards": "📋",
  "religious & spiritual": "🙏",
};

export function categoryEmoji(name) {
  if (typeof name !== "string") return "";
  return CATEGORY_EMOJI[name.trim().toLowerCase()] || "";
}
